import React from "react";
import { styled } from "@mui/system";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import {
  CustomLabel,
  CustomTableCellTitle,
  CustomTableCellValue,
} from "./CustomTypography";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
const StyledTable = styled(Table)({
  borderCollapse: "collapse",
  width: "100%",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
});

const StyledTableCell = styled(TableCell)({
  borderBottom: "1px solid #A5A5A5",
  padding: "10px 0px",
  textAlign: "center",
  justifyContent: "center",
});

const CustomTable = ({ data, titles, keys, t }) => {
  const navigate = useNavigate();
  console.log("daaa", data);
  const handleNavigate = (fpoId) => {
    navigate(`/fpo-farmer-list/${fpoId}`);
  };
  return (
    <StyledTable>
      <TableHead>
        <TableRow>
          <StyledTableCell>
            {<CustomTableCellTitle>{t("SR No")}.</CustomTableCellTitle>}
          </StyledTableCell>
          {/* Serial number column */}
          {titles.map((title, index) => (
            <StyledTableCell key={index}>
              {<CustomTableCellTitle>{title}</CustomTableCellTitle>}
            </StyledTableCell>
          ))}
          <StyledTableCell>
            <CustomLabel></CustomLabel>
          </StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item, rowIndex) => (
          <TableRow key={rowIndex}>
            <StyledTableCell>
              {<CustomTableCellValue>{rowIndex + 1}</CustomTableCellValue>}
            </StyledTableCell>
            {/* Serial number */}
            {keys.map((key, cellIndex) => (
              <StyledTableCell key={cellIndex}>
                {<CustomTableCellValue>{item[key]}</CustomTableCellValue>}
              </StyledTableCell>
            ))}
            <StyledTableCell style={{ paddingTop: "13px" }}>
              <KeyboardArrowRightIcon
                sx={{ fill: "#4CAF50" }}
                key={item.id}
                onClick={() => handleNavigate(item.id)}
              />
            </StyledTableCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};

export default CustomTable;
